module.exports = __webpack_public_path__ + "img/normal.167e16db.webp";